// Juniper doc: https://www.juniper.net/documentation/en_US/junos/topics/usage-guidelines/services-configuring-application-protocol-properties.html

export type IcmpType = {
  type: number;
  name: string;
  keys?: string[];
};

export function icmpTypes(): IcmpType[] {
  return [
    { type: 0, name: 'Echo Reply' },
    { type: 1, name: 'Unassigned' },
    { type: 2, name: 'Unassigned' },
    { type: 3, name: 'Destination Unreachable', keys: ['unreachable'] },
    { type: 4, name: 'Source Quench (Deprecated)' },
    { type: 5, name: 'Redirect', keys: ['redirect'] },
    { type: 6, name: 'Alternate Host Address (Deprecated)' },
    { type: 7, name: 'Unassigned' },
    { type: 8, name: 'Echo' },
    { type: 9, name: 'Router Advertisement' },
    { type: 10, name: 'Router Solicitation', keys: ['router-solicit'] },
    { type: 11, name: 'Time Exceeded' },
    { type: 12, name: 'Parameter Problem' },
    { type: 13, name: 'Timestamp', keys: ['timestamp'] },
    { type: 14, name: 'Timestamp Reply' },
    {
      type: 15,
      name: 'Information Request (Deprecated)',
      keys: ['info-request'],
    },
    { type: 16, name: 'Information Reply (Deprecated)', keys: ['info-reply'] },
    { type: 17, name: 'Address Mask Request (Deprecated)' },
    { type: 18, name: 'Address Mask Reply (Deprecated)' },
    { type: 19, name: 'Reserved (for Security)' },
    { type: 21, name: 'Reserved (for Robustness Experiment)' },
    { type: 22, name: 'Reserved (for Robustness Experiment)' },
    { type: 23, name: 'Reserved (for Robustness Experiment)' },
    { type: 24, name: 'Reserved (for Robustness Experiment)' },
    { type: 25, name: 'Reserved (for Robustness Experiment)' },
    { type: 26, name: 'Reserved (for Robustness Experiment)' },
    { type: 27, name: 'Reserved (for Robustness Experiment)' },
    { type: 28, name: 'Reserved (for Robustness Experiment)' },
    { type: 29, name: 'Reserved (for Robustness Experiment)' },
    { type: 30, name: 'Traceroute (Deprecated)', keys: ['traceroute'] },
    {
      type: 31,
      name: 'Datagram Conversion Error (Deprecated)',
      keys: ['conversion-error'],
    },
    {
      type: 32,
      name: 'Mobile Host Redirect (Deprecated)',
      keys: ['mobile-redirect', 'mobile-host-redirect'],
    },
    { type: 33, name: 'IPv6 Where-Are-You (Deprecated)' },
    { type: 34, name: 'IPv6 I-Am-Here (Deprecated)' },
    { type: 35, name: 'Mobile Registration Request (Deprecated)' },
    { type: 36, name: 'Mobile Registration Reply (Deprecated)' },
    { type: 37, name: 'Domain Name Request (Deprecated)' },
    { type: 38, name: 'Domain Name Reply (Deprecated)' },
    { type: 39, name: 'SKIP (Deprecated)' },
    { type: 40, name: 'Photuris' },
    {
      type: 41,
      name: 'ICMP messages utilized by experimental mobility protocols such as Seamoby',
    },
    { type: 42, name: 'Extended Echo Request' },
    { type: 43, name: 'Extended Echo Reply' },
    { type: 45, name: 'Unassigned' },
    { type: 46, name: 'Unassigned' },
    { type: 47, name: 'Unassigned' },
    { type: 48, name: 'Unassigned' },
    { type: 49, name: 'Unassigned' },
    { type: 50, name: 'Unassigned' },
    { type: 51, name: 'Unassigned' },
    { type: 52, name: 'Unassigned' },
    { type: 53, name: 'Unassigned' },
    { type: 54, name: 'Unassigned' },
    { type: 55, name: 'Unassigned' },
    { type: 56, name: 'Unassigned' },
    { type: 57, name: 'Unassigned' },
    { type: 58, name: 'Unassigned' },
    { type: 59, name: 'Unassigned' },
    { type: 60, name: 'Unassigned' },
    { type: 61, name: 'Unassigned' },
    { type: 62, name: 'Unassigned' },
    { type: 63, name: 'Unassigned' },
    { type: 64, name: 'Unassigned' },
    { type: 65, name: 'Unassigned' },
    { type: 66, name: 'Unassigned' },
    { type: 67, name: 'Unassigned' },
    { type: 68, name: 'Unassigned' },
    { type: 69, name: 'Unassigned' },
    { type: 70, name: 'Unassigned' },
    { type: 71, name: 'Unassigned' },
    { type: 72, name: 'Unassigned' },
    { type: 73, name: 'Unassigned' },
    { type: 74, name: 'Unassigned' },
    { type: 75, name: 'Unassigned' },
    { type: 76, name: 'Unassigned' },
    { type: 77, name: 'Unassigned' },
    { type: 78, name: 'Unassigned' },
    { type: 79, name: 'Unassigned' },
    { type: 80, name: 'Unassigned' },
    { type: 81, name: 'Unassigned' },
    { type: 82, name: 'Unassigned' },
    { type: 83, name: 'Unassigned' },
    { type: 84, name: 'Unassigned' },
    { type: 85, name: 'Unassigned' },
    { type: 86, name: 'Unassigned' },
    { type: 87, name: 'Unassigned' },
    { type: 88, name: 'Unassigned' },
    { type: 89, name: 'Unassigned' },
    { type: 90, name: 'Unassigned' },
    { type: 91, name: 'Unassigned' },
    { type: 92, name: 'Unassigned' },
    { type: 93, name: 'Unassigned' },
    { type: 94, name: 'Unassigned' },
    { type: 95, name: 'Unassigned' },
    { type: 96, name: 'Unassigned' },
    { type: 97, name: 'Unassigned' },
    { type: 98, name: 'Unassigned' },
    { type: 99, name: 'Unassigned' },
    { type: 100, name: 'Unassigned' },
    { type: 101, name: 'Unassigned' },
    { type: 102, name: 'Unassigned' },
    { type: 103, name: 'Unassigned' },
    { type: 104, name: 'Unassigned' },
    { type: 105, name: 'Unassigned' },
    { type: 106, name: 'Unassigned' },
    { type: 107, name: 'Unassigned' },
    { type: 108, name: 'Unassigned' },
    { type: 109, name: 'Unassigned' },
    { type: 110, name: 'Unassigned' },
    { type: 111, name: 'Unassigned' },
    { type: 112, name: 'Unassigned' },
    { type: 113, name: 'Unassigned' },
    { type: 114, name: 'Unassigned' },
    { type: 115, name: 'Unassigned' },
    { type: 116, name: 'Unassigned' },
    { type: 117, name: 'Unassigned' },
    { type: 118, name: 'Unassigned' },
    { type: 119, name: 'Unassigned' },
    { type: 120, name: 'Unassigned' },
    { type: 121, name: 'Unassigned' },
    { type: 122, name: 'Unassigned' },
    { type: 123, name: 'Unassigned' },
    { type: 124, name: 'Unassigned' },
    { type: 125, name: 'Unassigned' },
    { type: 126, name: 'Unassigned' },
    { type: 127, name: 'Unassigned' },
    { type: 128, name: 'Unassigned' },
    { type: 129, name: 'Unassigned' },
    { type: 130, name: 'Unassigned' },
    { type: 131, name: 'Unassigned' },
    { type: 132, name: 'Unassigned' },
    { type: 133, name: 'Unassigned' },
    { type: 134, name: 'Unassigned' },
    { type: 135, name: 'Unassigned' },
    { type: 136, name: 'Unassigned' },
    { type: 137, name: 'Unassigned' },
    { type: 138, name: 'Unassigned' },
    { type: 139, name: 'Unassigned' },
    { type: 140, name: 'Unassigned' },
    { type: 141, name: 'Unassigned' },
    { type: 142, name: 'Unassigned' },
    { type: 143, name: 'Unassigned' },
    { type: 144, name: 'Unassigned' },
    { type: 145, name: 'Unassigned' },
    { type: 146, name: 'Unassigned' },
    { type: 147, name: 'Unassigned' },
    { type: 148, name: 'Unassigned' },
    { type: 149, name: 'Unassigned' },
    { type: 150, name: 'Unassigned' },
    { type: 151, name: 'Unassigned' },
    { type: 152, name: 'Unassigned' },
    { type: 153, name: 'Unassigned' },
    { type: 154, name: 'Unassigned' },
    { type: 155, name: 'Unassigned' },
    { type: 156, name: 'Unassigned' },
    { type: 157, name: 'Unassigned' },
    { type: 158, name: 'Unassigned' },
    { type: 159, name: 'Unassigned' },
    { type: 160, name: 'Unassigned' },
    { type: 161, name: 'Unassigned' },
    { type: 162, name: 'Unassigned' },
    { type: 163, name: 'Unassigned' },
    { type: 164, name: 'Unassigned' },
    { type: 165, name: 'Unassigned' },
    { type: 166, name: 'Unassigned' },
    { type: 167, name: 'Unassigned' },
    { type: 168, name: 'Unassigned' },
    { type: 169, name: 'Unassigned' },
    { type: 170, name: 'Unassigned' },
    { type: 171, name: 'Unassigned' },
    { type: 172, name: 'Unassigned' },
    { type: 173, name: 'Unassigned' },
    { type: 174, name: 'Unassigned' },
    { type: 175, name: 'Unassigned' },
    { type: 176, name: 'Unassigned' },
    { type: 177, name: 'Unassigned' },
    { type: 178, name: 'Unassigned' },
    { type: 179, name: 'Unassigned' },
    { type: 180, name: 'Unassigned' },
    { type: 181, name: 'Unassigned' },
    { type: 182, name: 'Unassigned' },
    { type: 183, name: 'Unassigned' },
    { type: 184, name: 'Unassigned' },
    { type: 185, name: 'Unassigned' },
    { type: 186, name: 'Unassigned' },
    { type: 187, name: 'Unassigned' },
    { type: 188, name: 'Unassigned' },
    { type: 189, name: 'Unassigned' },
    { type: 190, name: 'Unassigned' },
    { type: 191, name: 'Unassigned' },
    { type: 192, name: 'Unassigned' },
    { type: 193, name: 'Unassigned' },
    { type: 194, name: 'Unassigned' },
    { type: 195, name: 'Unassigned' },
    { type: 196, name: 'Unassigned' },
    { type: 197, name: 'Unassigned' },
    { type: 198, name: 'Unassigned' },
    { type: 199, name: 'Unassigned' },
    { type: 200, name: 'Unassigned' },
    { type: 201, name: 'Unassigned' },
    { type: 202, name: 'Unassigned' },
    { type: 203, name: 'Unassigned' },
    { type: 204, name: 'Unassigned' },
    { type: 205, name: 'Unassigned' },
    { type: 206, name: 'Unassigned' },
    { type: 207, name: 'Unassigned' },
    { type: 208, name: 'Unassigned' },
    { type: 209, name: 'Unassigned' },
    { type: 210, name: 'Unassigned' },
    { type: 211, name: 'Unassigned' },
    { type: 212, name: 'Unassigned' },
    { type: 213, name: 'Unassigned' },
    { type: 214, name: 'Unassigned' },
    { type: 215, name: 'Unassigned' },
    { type: 216, name: 'Unassigned' },
    { type: 217, name: 'Unassigned' },
    { type: 218, name: 'Unassigned' },
    { type: 219, name: 'Unassigned' },
    { type: 220, name: 'Unassigned' },
    { type: 221, name: 'Unassigned' },
    { type: 222, name: 'Unassigned' },
    { type: 223, name: 'Unassigned' },
    { type: 224, name: 'Unassigned' },
    { type: 225, name: 'Unassigned' },
    { type: 226, name: 'Unassigned' },
    { type: 227, name: 'Unassigned' },
    { type: 228, name: 'Unassigned' },
    { type: 229, name: 'Unassigned' },
    { type: 230, name: 'Unassigned' },
    { type: 231, name: 'Unassigned' },
    { type: 232, name: 'Unassigned' },
    { type: 233, name: 'Unassigned' },
    { type: 234, name: 'Unassigned' },
    { type: 235, name: 'Unassigned' },
    { type: 236, name: 'Unassigned' },
    { type: 237, name: 'Unassigned' },
    { type: 238, name: 'Unassigned' },
    { type: 239, name: 'Unassigned' },
    { type: 240, name: 'Unassigned' },
    { type: 241, name: 'Unassigned' },
    { type: 242, name: 'Unassigned' },
    { type: 243, name: 'Unassigned' },
    { type: 244, name: 'Unassigned' },
    { type: 245, name: 'Unassigned' },
    { type: 246, name: 'Unassigned' },
    { type: 247, name: 'Unassigned' },
    { type: 248, name: 'Unassigned' },
    { type: 249, name: 'Unassigned' },
    { type: 250, name: 'Unassigned' },
    { type: 251, name: 'Unassigned' },
    { type: 252, name: 'Unassigned' },
    { type: 253, name: 'RFC3692-style Experiment 1' },
    { type: 254, name: 'RFC3692-style Experiment 2' },
    { type: 255, name: 'Reserved' },
  ];
}
